
import {
  axiosget,
  axiospost,
  axiosdelete,
  axiosput,
  dataUrl
} from 'utils/axiosMethods'

export default class preAxios {
  $axiosget = axiosget;
  $axiospost = axiospost;
  $axiosdelete = axiosdelete;
  $axiosput = axiosput;
  dataUrl = dataUrl;
}


// WEBPACK FOOTER //
// ./src/ts/API/preAxios.ts